<!-- SELECTS -->
<div class="input-component"
     *ngIf="component.type == ComponentType.SELECT"
     [attr.data-editable]="isEditable"
     [attr.data-type]="componentFullType">
  <div>
    <div class="cdc-form-field-container">
      <!-- <div class="custom-tooltip tooltip-{{ generatedIndex }}" #customTooltip>{{errorMessages[generatedIndex]}}</div> -->
      <div>
        <!-- select dropwdown multiple -->
        <div *ngIf="component.config?.selectType == SelectType.LIST_DROP && component.config?.multipleAnswers" class="w-100">
          <div class="cdc-label">
            <span class="text-new-lines" *ngIf="component.title && component.title.trim() !== ''">
              {{ component.title }}
            </span>
            <span *ngIf="dataIndex !== undefined && component.title">{{dataIndex}}</span>
            <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
          </div>
          <div class="cdc-label-description text-new-lines" *ngIf="component.description && component.description.trim() !== ''">
            {{ component.description }}
          </div>
          <div class="cdc-form-field w-100 p-1" [ngClass]="{
            'error': errorMessages[generatedIndex],
            'actif': !isAllValuesComponentEmpty() && isEditable
          }">
            <div class="field-{{generatedIndex}}">
              <div class="custom-tooltip tooltip-{{ generatedIndex }}" #customTooltip>{{errorMessages[generatedIndex]}}</div>
              <div class="summary-edit-area"
                   #fieldContainer [attr.data-block-id]="block.id" [attr.data-block-iteration]="block.iteration" [attr.data-component-id]="component.id" [attr.data-component-multiple-iteration]="0" [attr.data-dataGroup-id]="this.customerPageData.dataGroupId"
                   [matTooltip]="(isSummary && isEditableWhenNotSummary) ? ('Click here to modify the answer on the questionnaire' | translate) : '' ">
                <mat-form-field class="select-container select-chips field-{{generatedIndex}} w-100">
                  <mat-chip-grid #chipList>

                    <mat-chip *ngFor="let value of customerPageDataValuesInString"
                              (removed)="removeChip(value)"
                              [removable]="isEditable"
                              [tippy]="isHtml(getOptionDisplay(value)) ? getOptionDisplay(value) : ''" placement="left" theme="light-white">
                      <ng-container *ngIf="getOptionLogo(value) as logo">
                        <img class="option-image" [src]="logo">
                      </ng-container>
                      <span *ngIf="component.config?.optionsType == OptionsType.CERTIFICATIONS">{{value}} - </span>
                      {{ stripHtml(getOptionDisplay(value)) }}
                      <button matChipRemove *ngIf="isEditable">
                        <mat-icon>cancel</mat-icon>
                      </button>
                    </mat-chip>

                    <input [placeholder]="isEditable ? (component.config?.placeholder || '') : ''"
                           #optionInput
                           [formControl]="optionCtrl"
                           [matAutocomplete]="auto"
                           [matChipInputFor]="chipList"
                           [disabled]="!isEditable"
                           (click)="onClickInputSelectMultiple(generatedIndex)"
                           (blur)="onSelectMultipleFocusOut()"
                           class="select-input-multiple" />
                  </mat-chip-grid>

                  <mat-autocomplete #auto="matAutocomplete"
                                    (opened)="onPanelOpen('select')"
                                    (optionSelected)="onChipSelected($event)"
                                    autoActiveFirstOption>
                    <ng-container *ngIf="filteredState | async as state">
                      <mat-option *ngIf="state.isWaitingForInput" [disabled]="true">
                        {{"Type to search" | translate}}
                      </mat-option>

                      <mat-option *ngIf="state.notFound" [disabled]="true">
                        {{"Not found" | translate}}
                      </mat-option>

                      <mat-option *ngFor="let option of state.filteredOptions" [value]="option.value">
                        <img *ngIf="option.logoPath" class="option-image" [src]="option.logoPath">
                        <span *ngIf="component.config?.optionsType == OptionsType.CERTIFICATIONS">{{option.value}} - </span>
                        <span class="el-html-content" [innerHtml]="sanitizeHtml(option.display)"></span>
                      </mat-option>
                    </ng-container>
                  </mat-autocomplete>

                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <!-- select dropwdown single -->
        <div *ngIf="component.config?.selectType == SelectType.LIST_DROP && !component.config?.multipleAnswers">
          <div class="cdc-form-field-container">
            <div class="cdc-label">
              <span class="text-new-lines" *ngIf="component.title && component.title.trim() !== ''">
                {{ component.title }}
              </span>
              <mat-icon class="component-title-help"
                        *ngIf="component.helpText && component.helpText.length > 0"
                        matTooltipClass="multiline-tooltip"
                        matTooltip="{{component.helpText}}"
                        [matTooltipPosition]="'right'"
                        (click)="toggleTooltip(tooltip1)"
                        #tooltip1="matTooltip">help</mat-icon>
              <span *ngIf="dataIndex !== undefined && component.title">{{dataIndex}}</span>
              <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
            </div>
            <div class="cdc-label-description text-new-lines" *ngIf="component.description && component.description.trim() !== ''">
              {{ component.description }}
            </div>
            <div class="cdc-form-field w-100 p-1"
                 [ngClass]="{
                'error': errorMessages[generatedIndex],
                'actif': !isAllValuesComponentEmpty() && isEditable
              }">
              <div class="custom-tooltip tooltip-{{ generatedIndex }}" #customTooltip>{{errorMessages[generatedIndex]}}</div>
              <div class="summary-edit-area"
                   #fieldContainer [attr.data-block-id]="block.id" [attr.data-block-iteration]="block.iteration" [attr.data-component-id]="component.id" [attr.data-component-multiple-iteration]="0" [attr.data-dataGroup-id]="this.customerPageData.dataGroupId"
                   [matTooltip]="(isSummary && isEditableWhenNotSummary) ? ('Click here to modify the answer on the questionnaire' | translate) : '' ">
                <div class="select-container field-{{generatedIndex}}">
                  <input type="text"
                         matInput
                         [placeholder]="isEditable ? (component.config!.placeholder || '') : ''"
                         [matAutocomplete]="auto"
                         [formControl]="optionCtrl"
                         [readonly]="true"
                         (click)="openPanelManually(generatedIndex)"
                         (blur)="onSelectSingleFocusOut()"
                         [tippy]="tooltipContent" placement="left" theme="light-white"/>

                  <mat-autocomplete #auto="matAutocomplete"
                                    [displayWith]="displayOption"
                                    (optionSelected)="onSelectSingleChange($event.option.value)"
                                    (opened)="onPanelOpen('select')"
                                    (optionActivated)="onOptionActivated($event)"
                                    autoActiveFirstOption>
                    <div *ngIf="allOptions.length > 6" class="search-input-container" (click)="$event.stopPropagation()">
                      <mat-icon matPrefix>search</mat-icon>
                      <input #searchInput
                             type="text"
                             [placeholder]="isEditable ? (('Search' | translate) + '...') : ''"
                             [formControl]="searchCtrl"
                             class="mat-autocomplete-search-input"
                             (keydown.enter)="onSelectSearchEnter($event)" />
                    </div>
                    <hr class="search-divider">
                    <ng-container *ngIf="filteredState | async as state">
                      <mat-option *ngIf="state.isWaitingForInput" [disabled]="true">
                        {{"Type to search" | translate}}
                      </mat-option>
                      <mat-option *ngIf="state.notFound" [disabled]="true">
                        {{"Not found" | translate}}
                      </mat-option>
                      <mat-option *ngFor="let option of state.filteredOptions" [value]="option.value">
                        <img *ngIf="option.logoPath" class="option-image" [src]="option.logoPath">
                        <span *ngIf="component.config?.optionsType == OptionsType.CERTIFICATIONS">{{option.value}} - </span>
                        <span class="el-html-content" [innerHtml]="sanitizeHtml(option.display)"></span>
                      </mat-option>
                    </ng-container>
                  </mat-autocomplete>

                  <mat-icon *ngIf="customerPageData.values[0] && isEditable"
                            class="clear-button"
                            matSuffix
                            mat-icon-button
                            type="button"
                            aria-label="Clear"
                            (click)="resetSelectOption($event)">close</mat-icon>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- select LIST_CARD single/multiple -->
        <section *ngIf="component.config?.selectType == SelectType.LIST_CARD" class="d-flex flex-column cdc-form-field p-1">
          <div class="cdc-form-field-container">
            <div class="cdc-label">
              <span class="text-new-lines" *ngIf="component.title && component.title.trim() !== ''">
                {{ component.title }}
              </span>
              <mat-icon class="component-title-help"
                        *ngIf="component.helpText && component.helpText.length > 0"
                        matTooltipClass="multiline-tooltip"
                        matTooltip="{{component.helpText}}"
                        [matTooltipPosition]="'right'"
                        (click)="toggleTooltip(tooltip3)"
                        #tooltip3="matTooltip">help</mat-icon>
              <span *ngIf="dataIndex !== undefined && component.title">{{dataIndex}}</span>
              <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
            </div>
            <div class="cdc-label-description text-new-lines" *ngIf="component.description && component.description.trim() !== ''">
              {{ component.description }}
            </div>
            <div class="custom-tooltip tooltip-{{ generatedIndex }}" #customTooltip>{{errorMessages[generatedIndex]}}</div>
            <div class="field-{{generatedIndex}}">
              <div class="summary-edit-area"
                   #fieldContainer [attr.data-block-id]="block.id" [attr.data-block-iteration]="block.iteration" [attr.data-component-id]="component.id" [attr.data-component-multiple-iteration]="0" [attr.data-dataGroup-id]="this.customerPageData.dataGroupId"
                   [matTooltip]="(isSummary && isEditableWhenNotSummary) ? ('Click here to modify the answer on the questionnaire' | translate) : '' ">
                <div class="d-flex flex-column">
                  <div style="display: grid; gap: 16px; width: 100%;" [style.grid-template-columns]="'repeat(' + getGridColumns(component) + ', 1fr)'">
                      <ng-container *ngFor="let option of component.config?.options">
                        <div *ngIf="!isSummary || customerPageDataValuesInString.includes(option.value)" class="">
                          <div class="container-element">

                            <app-card-select-component attr.data-componentid="{{ component.id }}" attr.data-value="{{ option.value }}"
                                                       [disabled]="!isEditable"
                                                       [option]="option"
                                                       [checked]="customerPageDataValuesInString.includes(option.value)"
                                                       (click)="displayCurrentErrorTooltip(generatedIndex)"
                                                       (cardChange)="onCardSelectionChange($event)"
                                                       [ngClass]="{'not-allowed': !isEditable, 'error': errorMessages[generatedIndex] }">
                            </app-card-select-component>

                          </div>
                          <div class="container-element w-100" *ngIf="itsConditioner && hasComponentsConditionedClosedDisplayed(option.value)">
                            <div *ngFor="let componentConditioned of getConditionedComponents('display', true, option.value)">
                              <app-component-form [customerPageData]="getCustomerPageDataByComponentId(componentConditioned.id, customerPageData.dataGroupId)"
                                                  [component]="componentConditioned"
                                                  [block]="block"
                                                  [customerId]="customerId"
                                                  [dataGroupCustomerPageData]="dataGroupCustomerPageData"
                                                  [groupCustomerPageData]="groupCustomerPageData"
                                                  [pageCustomerPageData]="pageCustomerPageData"
                                                  [totalDataGroups]="totalDataGroups"
                                                  [isConditionedClosed]="true"
                                                  [userRole]="userRole"
                                                  [customer]="customer"
                                                  [isSummary]="isSummary"
                                                  [offerStatus]="offerStatus"
                                                  [dataIndex]="dataIndex"
                                                  [index]="index"
                                                  [customerPage]="customerPage"
                                                  [refBusinessLists]="refBusinessLists"
                                                  [fullConnectionsDefinitions]="fullConnectionsDefinitions"
                                                  [isCurrentBlock]="isCurrentBlock"
                                                  (customersDataChange)="handleCustomerPageDatasChange($event)"
                                                  (scrollToSchedule)="scrollToScheduleEvent($event)"
                                                  (tooltipPosition)="onTooltipPositionChanged($event)"
                                                  (fieldContainerClick)="onFieldContainerClick($event)"
                                                  (recalculateTooltipsPosition)="recalculateTooltipsPositionEmit()"
                                                  (closeAllTooltipsExceptCurrent)="closeAllTooltipsExceptCurrentEmit($event)"
                                                  (activityChanged)="onConditionedActivityChanged()"
                                                  [activitiesAlreadySelected]="activitiesAlreadySelected">
                              </app-component-form>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
              </div>
            </div>

          </div>
        </section>
        <!-- select LIST_NO_DROP single (radio) -->
        <section *ngIf="component.config?.selectType == SelectType.LIST_NO_DROP && !component.config?.multipleAnswers">
          <mat-radio-group [(ngModel)]="customerPageData.values[0]" (ngModelChange)="onSelectSingleChange($event)" class="d-flex flex-column cdc-form-field p-1">
            <div class="cdc-form-field-container">
              <div class="cdc-label">
                <span class="text-new-lines" *ngIf="component.title && component.title.trim() !== ''">
                  {{ component.title }}
                </span>
                <mat-icon class="component-title-help"
                          *ngIf="component.helpText && component.helpText.length > 0"
                          matTooltipClass="multiline-tooltip"
                          matTooltip="{{component.helpText}}"
                          [matTooltipPosition]="'right'"
                          (click)="toggleTooltip(tooltip2)"
                          #tooltip2="matTooltip">help</mat-icon>
                <span *ngIf="dataIndex !== undefined && component.title">{{dataIndex}}</span>
                <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
              </div>
              <div class="cdc-label-description text-new-lines" *ngIf="component.description && component.description.trim() !== ''">
                {{ component.description }}
              </div>

              <div class="custom-tooltip tooltip-{{ generatedIndex }}" #customTooltip>{{errorMessages[generatedIndex]}}</div>
              <div class="field-{{generatedIndex}}">
                <div class="summary-edit-area"
                     #fieldContainer [attr.data-block-id]="block.id" [attr.data-block-iteration]="block.iteration" [attr.data-component-id]="component.id" [attr.data-component-multiple-iteration]="0" [attr.data-dataGroup-id]="this.customerPageData.dataGroupId"
                     [matTooltip]="(isSummary && isEditableWhenNotSummary) ? ('Click here to modify the answer on the questionnaire' | translate) : '' ">
                  <div class="d-flex flex-column">
                    <ng-container *ngFor="let option of component.config?.options">
                      <div class=" flex-column">
                        <div class="container-element">
                          <mat-radio-button class="mat-radio-button"
                                            attr.data-componentid="{{ component.id }}"
                                            attr.data-value="{{ option.value }}"
                                            [value]="option.value"
                                            [disabled]="!isEditable"
                                            (change)="onRadioSelect(option.value)"
                                            [ngClass]="{'not-allowed': !isEditable}">
                            <div class="el-html-content" [innerHtml]="sanitizeHtml(option.display)"></div>
                          </mat-radio-button>
                        </div>
                        <div class="container-element w-100 conditioned-elem-radio" *ngIf="itsConditioner && hasComponentsConditionedClosedDisplayed(option.value)">
                          <div *ngFor="let componentConditioned of getConditionedComponents('display', true, option.value)">
                            <app-component-form [customerPageData]="getCustomerPageDataByComponentId(componentConditioned.id, customerPageData.dataGroupId)"
                                                [component]="componentConditioned"
                                                [block]="block"
                                                [customerId]="customerId"
                                                [dataGroupCustomerPageData]="dataGroupCustomerPageData"
                                                [groupCustomerPageData]="groupCustomerPageData"
                                                [pageCustomerPageData]="pageCustomerPageData"
                                                [totalDataGroups]="totalDataGroups"
                                                [isConditionedClosed]="true"
                                                [userRole]="userRole"
                                                [customer]="customer"
                                                [isSummary]="isSummary"
                                                [offerStatus]="offerStatus"
                                                [dataIndex]="dataIndex"
                                                [index]="index"
                                                [customerPage]="customerPage"
                                                [refBusinessLists]="refBusinessLists"
                                                [fullConnectionsDefinitions]="fullConnectionsDefinitions"
                                                [isCurrentBlock]="isCurrentBlock"
                                                (customersDataChange)="handleCustomerPageDatasChange($event)"
                                                (scrollToSchedule)="scrollToScheduleEvent($event)"
                                                (tooltipPosition)="onTooltipPositionChanged($event)"
                                                (fieldContainerClick)="onFieldContainerClick($event)"
                                                (recalculateTooltipsPosition)="recalculateTooltipsPositionEmit()"
                                                (closeAllTooltipsExceptCurrent)="closeAllTooltipsExceptCurrentEmit($event)"
                                                (activityChanged)="onConditionedActivityChanged()"
                                                [activitiesAlreadySelected]="activitiesAlreadySelected">
                            </app-component-form>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>

              </div>

            </div>
          </mat-radio-group>
        </section>
        <!-- select LIST_NO_DROP multiple (checkbox)-->
        <section *ngIf="component.config?.selectType == SelectType.LIST_NO_DROP && component.config?.multipleAnswers" class="d-flex flex-column cdc-form-field p-1">
          <div class="cdc-form-field-container">
            <div class="cdc-label">
              <span class="text-new-lines" *ngIf="component.title && component.title.trim() !== ''">
                {{ component.title }}
              </span>
              <mat-icon class="component-title-help"
                        *ngIf="component.helpText && component.helpText.length > 0"
                        matTooltipClass="multiline-tooltip"
                        matTooltip="{{component.helpText}}"
                        [matTooltipPosition]="'right'"
                        (click)="toggleTooltip(tooltip3)"
                        #tooltip3="matTooltip">help</mat-icon>
              <span *ngIf="dataIndex !== undefined && component.title">{{dataIndex}}</span>
              <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
            </div>
            <div class="cdc-label-description text-new-lines" *ngIf="component.description && component.description.trim() !== ''">
              {{ component.description }}
            </div>
            <div class="custom-tooltip tooltip-{{ generatedIndex }}" #customTooltip>{{errorMessages[generatedIndex]}}</div>
            <div class="field-{{generatedIndex}}">
              <div class="summary-edit-area"
                   #fieldContainer [attr.data-block-id]="block.id" [attr.data-block-iteration]="block.iteration" [attr.data-component-id]="component.id" [attr.data-component-multiple-iteration]="0" [attr.data-dataGroup-id]="this.customerPageData.dataGroupId"
                   [matTooltip]="(isSummary && isEditableWhenNotSummary) ? ('Click here to modify the answer on the questionnaire' | translate) : '' ">
                <div class="d-flex flex-column">
                  <ng-container *ngFor="let option of component.config?.options">
                    <div class="">
                      <div class="container-element" [ngClass]="{'not-allowed': !isEditable}">
                        <mat-checkbox attr.data-componentid="{{ component.id }}" attr.data-value="{{ option.value }}"
                                      [checked]="customerPageDataValuesInString.includes(option.value)"
                                      (click)="displayCurrentErrorTooltip(generatedIndex)"
                                      (change)="onCheckboxChange(option.value, $event)"
                                      [disabled]="!isEditable">
                          <div class="el-html-content" [innerHtml]="sanitizeHtml(option.display)"></div>
                        </mat-checkbox>
                      </div>
                      <div class="container-element w-100" *ngIf="itsConditioner && hasComponentsConditionedClosedDisplayed(option.value)">
                        <div *ngFor="let componentConditioned of getConditionedComponents('display', true, option.value)">
                          <app-component-form [customerPageData]="getCustomerPageDataByComponentId(componentConditioned.id, customerPageData.dataGroupId)"
                                              [component]="componentConditioned"
                                              [block]="block"
                                              [customerId]="customerId"
                                              [dataGroupCustomerPageData]="dataGroupCustomerPageData"
                                              [groupCustomerPageData]="groupCustomerPageData"
                                              [pageCustomerPageData]="pageCustomerPageData"
                                              [totalDataGroups]="totalDataGroups"
                                              [isConditionedClosed]="true"
                                              [userRole]="userRole"
                                              [customer]="customer"
                                              [isSummary]="isSummary"
                                              [offerStatus]="offerStatus"
                                              [dataIndex]="dataIndex"
                                              [index]="index"
                                              [customerPage]="customerPage"
                                              [refBusinessLists]="refBusinessLists"
                                              [fullConnectionsDefinitions]="fullConnectionsDefinitions"
                                              [isCurrentBlock]="isCurrentBlock"
                                              (customersDataChange)="handleCustomerPageDatasChange($event)"
                                              (scrollToSchedule)="scrollToScheduleEvent($event)"
                                              (tooltipPosition)="onTooltipPositionChanged($event)"
                                              (fieldContainerClick)="onFieldContainerClick($event)"
                                              (recalculateTooltipsPosition)="recalculateTooltipsPositionEmit()"
                                              (closeAllTooltipsExceptCurrent)="closeAllTooltipsExceptCurrentEmit($event)"
                                              (activityChanged)="onConditionedActivityChanged()"
                                              [activitiesAlreadySelected]="activitiesAlreadySelected">
                          </app-component-form>
                        </div>
                      </div>
                    </div>

                  </ng-container>
                </div>
              </div>
            </div>

          </div>
        </section>

      </div>
    </div>
  </div>
</div>

<!-- INPUT -->
<div class="d-flex flex-row gap-2"
     *ngIf="component.type == ComponentType.INPUT && component.config?.inputType != InputType.FILE && component.config?.inputType != InputType.COLOR_PICKER"
     [attr.data-editable]="isEditable"
     [attr.data-type]="componentFullType">
  <div class="input-component w-100">
    <div class="container-element w-100">
      <div class="col-12 col-lg-12 col-md-12 d-flex flex-row align-items-end">
        <div class="cdc-form-field-container w-100">
          <div class="cdc-label" *ngIf="component.title || component.helpText || dataIndex || component.isRequired === true">
            <span class="text-new-lines" *ngIf="component.title && component.title.trim() !== ''">
              {{ component.title }}
            </span>
            <mat-icon class="component-title-help"
                      *ngIf="component.helpText && component.helpText.length > 0"
                      matTooltipClass="multiline-tooltip"
                      matTooltip="{{component.helpText}}"
                      [matTooltipPosition]="'right'"
                      (click)="toggleTooltip(tooltip4)"
                      #tooltip4="matTooltip">help</mat-icon>
            <span *ngIf="dataIndex !== undefined && component.title">{{dataIndex}}</span>
            <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
          </div>

          <div *ngIf="component.description && component.description.trim() !== ''" class="cdc-label-description text-new-lines">
            {{ component.description }}
          </div>

          <div class="cdc-form-field d-flex flex-row align-items-end gap-2 p-1"
               *ngFor="let value of customerPageDataValuesInString; let i = index; trackBy: trackByFn"
               [ngClass]="{
            'error': errorMessages[generatedIndex+'-'+i],
            'actif': customerPageData.values[i] && isEditable,
            'm-0':isConditionedClosed}">

            <div class="d-flex flex-row align-items-center gap-2 w-100">
              <div [ngClass]="{'w-95': canRemoveAnswers(), 'w-100': !canRemoveAnswers()}">
                <div class="custom-tooltip tooltip-{{ generatedIndex }}-{{i}}" #customTooltip>{{errorMessages[generatedIndex+'-'+i]}}</div>
                <div class="summary-edit-area"
                     #fieldContainer [attr.data-block-id]="block.id" [attr.data-block-iteration]="block.iteration" [attr.data-component-id]="component.id" [attr.data-component-multiple-iteration]="i" [attr.data-dataGroup-id]="this.customerPageData.dataGroupId"
                     [matTooltip]="(isSummary && isEditableWhenNotSummary) ? ('Click here to modify the answer on the questionnaire' | translate) : ''">

                  <!-- input text -->
                  <input matInput
                         class="field-{{generatedIndex}}-{{i}}"
                         *ngIf="component.config?.inputType == InputType.TEXT"
                         type="text" attr.data-componentid="{{ component.id }}"
                         autocomplete="off"
                         attr.data-value="{{ customerPageData.values[i] }}"
                         [placeholder]="isEditable ? (component.config?.placeholder + (component.multipleConfig?.haveIndexTitles ? ' ' + (i+1) : '')) : ''"
                         [(ngModel)]="customerPageData.values[i]"
                         [disabled]="!isEditable"
                         [ngClass]="{'not-allowed': !isEditable}"
                         (focus)="toggleMask(i, true)"
                         (click)="displayCurrentErrorTooltip(generatedIndex+'-'+i)"
                         (focusout)="onInputSave(customerPageData.values[i], i)"
                         (ngModelChange)="onInputTextInsert(customerPageData.values[i], i)"
                         [mask]="component.config?.mask?.mask || ''"
                         [dropSpecialCharacters]="component.config?.mask?.dropSpecialCharacters ?? false"
                         [validation]="false"
                         [prefix]="component.config?.mask?.prefix || ''"
                         [suffix]="component.config?.mask?.suffix || ''"
                         [thousandSeparator]="component.config?.mask?.thousandSeparator || ''"
                         [decimalMarker]="component.config?.mask?.decimalMarker ?? ','"
                         [showMaskTyped]="component.config?.mask != undefined && component.config?.mask?.mask != undefined && component.config?.mask?.mask != '' && showMaskTypedList[generatedIndex+'-'+i] && (component.config?.mask?.showMaskTyped ?? false)"
                         [placeHolderCharacter]="component.config?.mask?.placeHolderCharacter ?? null">

                  <!-- input text area -->
                  <textarea matInput
                            class="field-{{generatedIndex}}-{{i}} textarea"
                            *ngIf="component.config?.inputType == InputType.TEXT_AREA"
                            attr.data-componentid="{{ component.id }}"
                            attr.data-value="{{ customerPageData.values[i] }}"
                            [placeholder]="isEditable ? (component.config?.placeholder + (component.multipleConfig?.haveIndexTitles ? ' ' + (i+1) : '')) : ''"
                            [(ngModel)]="customerPageData.values[i]"
                            (click)="displayCurrentErrorTooltip(generatedIndex+'-'+i)"
                            (focusout)="onInputSave(customerPageData.values[i], i)"
                            (ngModelChange)="onCustomerPageDataChange()"
                            rows="3"
                            #autoResizeTextarea
                            (focusin)="adjustTextareaHeight($event)"
                            (input)="adjustTextareaHeight($event)"
                            [disabled]="!isEditable"
                            [ngClass]="{'not-allowed': !isEditable}">
                  </textarea>

                  <!-- input number -->
                  <input matInput
                         class="field-{{generatedIndex}}-{{i}}"
                         *ngIf="component.config?.inputType == InputType.NUMBER"
                         type="number"
                         autocomplete="off"
                         attr.data-componentid="{{ component.id }}"
                         attr.data-value="{{ customerPageData.values[i] }}"
                         [placeholder]="isEditable ? (component.config?.placeholder + (component.multipleConfig?.haveIndexTitles ? ' ' + (i+1) : '')) : ''"
                         [(ngModel)]="customerPageData.values[i]"
                         (click)="displayCurrentErrorTooltip(generatedIndex+'-'+i)"
                         (ngModelChange)="onInputSave(customerPageData.values[i], i)"
                         (input)="limitDigits($event, i)"
                         [disabled]="!isEditable"
                         [ngClass]="{'not-allowed': !isEditable}">

                  <!-- input date -->
                  <input matInput
                         class="field-{{generatedIndex}}-{{i}}"
                         *ngIf="component.config?.inputType == InputType.DATE"
                         type="date"
                         autocomplete="off"
                         placeholder=""
                         [(ngModel)]="customerPageData.values[i]"
                         (click)="displayCurrentErrorTooltip(generatedIndex+'-'+i)"
                         (focusout)="onInputSave(customerPageData.values[i], i)"
                         (ngModelChange)="onCustomerPageDataChange()"
                         [disabled]="!isEditable"
                         [ngClass]="{'not-allowed': !isEditable}">
                </div>
              </div>

              <mat-icon class="remove-answer" *ngIf="canRemoveAnswers()" matTooltip="{{ 'Remove answer' | translate }}" (click)="removeAnswer(i)">close</mat-icon>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="container-element w-100" *ngIf="itsConditioner && hasComponentsConditionedClosedDisplayed()">
    <div *ngFor="let componentConditioned of getConditionedComponents('display', true)">
      <app-component-form [customerPageData]="getCustomerPageDataByComponentId(componentConditioned.id, customerPageData.dataGroupId)"
                          [component]="componentConditioned"
                          [block]="block"
                          [customerId]="customerId"
                          [dataGroupCustomerPageData]="dataGroupCustomerPageData"
                          [groupCustomerPageData]="groupCustomerPageData"
                          [pageCustomerPageData]="pageCustomerPageData"
                          [totalDataGroups]="totalDataGroups"
                          [isConditionedClosed]="true"
                          [userRole]="userRole"
                          [customer]="customer"
                          [isSummary]="isSummary"
                          [offerStatus]="offerStatus"
                          [dataIndex]="dataIndex"
                          [index]="index"
                          [customerPage]="customerPage"
                          [refBusinessLists]="refBusinessLists"
                          [fullConnectionsDefinitions]="fullConnectionsDefinitions"
                          [isCurrentBlock]="isCurrentBlock"
                          (customersDataChange)="handleCustomerPageDatasChange($event)"
                          (scrollToSchedule)="scrollToScheduleEvent($event)"
                          (tooltipPosition)="onTooltipPositionChanged($event)"
                          (fieldContainerClick)="onFieldContainerClick($event)"
                          (recalculateTooltipsPosition)="recalculateTooltipsPositionEmit()"
                          (closeAllTooltipsExceptCurrent)="closeAllTooltipsExceptCurrentEmit($event)"
                          (activityChanged)="onConditionedActivityChanged()"
                          [activitiesAlreadySelected]="activitiesAlreadySelected">
      </app-component-form>
    </div>
  </div>
</div>

<!-- UPLOAD FILE -->
<div *ngIf="(component.type == ComponentType.INPUT && component.config?.inputType == InputType.FILE) || component.type == ComponentType.VISUAL_PUBLICATION"
     [attr.data-editable]="isEditable"
     [attr.data-type]="componentFullType">
  <div class="d-flex flex-row align-items-center">
    <div class="custom-tooltip tooltip-{{ generatedIndex }}" #customTooltip>{{errorMessages[generatedIndex]}}</div>
    <div class="w-100 input-component field-{{generatedIndex}}">
      <div class="container-element w-100">
        <div id="uploadEquipe" class="RadAsyncUpload RadUpload RadUpload_Default cdc-form-field">
          <div class="cdc-form-field-container">
            <div class="ruInputs" id="uploadEquipeListContainer">
              <div class="cdc-label">
                <span class="text-new-lines" *ngIf="component.title && component.title.trim() !== ''">
                  {{ component.title }}
                </span>
                <mat-icon class="component-title-help"
                          *ngIf="component.helpText && component.helpText.length > 0"
                          matTooltipClass="multiline-tooltip"
                          matTooltip="{{component.helpText}}"
                          [matTooltipPosition]="'right'"
                          (click)="toggleTooltip(tooltip5)"
                          #tooltip5="matTooltip">help</mat-icon>
                <span *ngIf="dataIndex !== undefined && component.title">{{dataIndex}}</span>
                <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
              </div>
              <div class="cdc-label-description text-new-lines" *ngIf="component.description && component.description.trim() !== ''">
                {{ component.description }}
              </div>
              <div class="summary-edit-area"
                   #fieldContainer [attr.data-block-id]="block.id" [attr.data-block-iteration]="block.iteration" [attr.data-component-id]="component.id" [attr.data-component-multiple-iteration]="0" [attr.data-dataGroup-id]="this.customerPageData.dataGroupId"
                   [matTooltip]="(isSummary && isEditableWhenNotSummary) ? ('Click here to modify the answer on the questionnaire' | translate) : '' ">
                <div class="FileUploadInput">
                  <div class="FileUploadInputItem FileUploadInputItemAdd" *ngIf="isEditable && (component.config?.multipleAnswers || filesData.length == 0)" [ngClass]="{'not-allowed': !isEditable}">
                    <input type="file"
                           class="ruFileInput"
                           (click)="displayCurrentErrorTooltip(generatedIndex)"
                           (change)="handleInsertImage($event)"
                           [disabled]="!isEditable"
                           [attr.multiple]="component.config?.multipleAnswers ? true : null"
                           [attr.accept]="extensionsString"
                           [ngClass]="{'not-allowed': !isEditable}">
                    <div *ngIf="hasOnlyOneFileType(); else multipleFilesTemplate">
                      <div [ngSwitch]="getSingleFileType()">
                        <div *ngSwitchCase="'IMAGE'">
                          <mat-icon>add_a_photo</mat-icon>
                        </div>
                        <div *ngSwitchCase="'VIDEO'">
                          <mat-icon>video_call</mat-icon>
                        </div>
                        <div *ngSwitchCase="'OFFICE'">
                          <mat-icon>description</mat-icon>
                        </div>
                        <div *ngSwitchDefault>
                          <mat-icon>archive</mat-icon>
                        </div>
                      </div>
                    </div>

                    <ng-template #multipleFilesTemplate>
                      <mat-icon>archive</mat-icon>
                    </ng-template>

                    <span class="break-word">{{component.config?.text ? component.config?.text : ('Add Files' | translate )}}</span>
                  </div>

                  <ng-container *ngFor="let file of filesData">
                    <div class="FileUploadInputItem" [ngClass]="{ 'FileUploadInputItemImage': file.fileCategory === 'IMAGE', 'FileUploadInputItemOthers': file.fileCategory === 'VIDEO' || file.fileCategory  === 'OFFICE', 'FileUploadInputItemWarning': file.fileCategory === 'WRONG_EXTENSION' || file.fileCategory === 'ERROR_FILE'}" [matTooltipPosition]="'above'"
                         [matTooltip]="
                            file.fileCategory === 'WRONG_EXTENSION' ? (file.fileName! + ' (' + ('Wrong file type' | translate) + ')') :
                            file.fileCategory === 'ERROR_FILE' ? (file.fileName! + ' (' + ('Error uploading file' | translate) + ')') :
                            file.fileCategory !== 'IMAGE' ? file.fileName! : ''
                          ">
                      <div class="FileUploadInputItemType">
                        <img [src]="(file.urlThumbnail && file.urlThumbnail != '') ? file.urlThumbnail : (file.url == '' ? '../../../../../../../assets/img/not-found.png' : file.url)" *ngIf="file.fileCategory === 'IMAGE'">
                        <mat-icon *ngIf="file.fileCategory === 'VIDEO'">video_call</mat-icon>
                        <mat-icon *ngIf="file.fileCategory === 'OFFICE'">description</mat-icon>
                        <mat-icon *ngIf="file.fileCategory == 'WRONG_EXTENSION' || file.fileCategory == 'ERROR_FILE'">warning</mat-icon>
                        <span *ngIf="file.fileCategory != 'IMAGE'">{{ getFileExtension(file.fileName!) }}</span>
                      </div>
                      <div class="FileUploadInputItemStatus" [ngClass]="{ 'FileUploadUploading': file.fileStatus === FileStatus.UPLOADING, 'FileUploadError': file.fileStatus === FileStatus.ERROR}" *ngIf="file.url == undefined">
                        <span *ngIf="file.fileStatus === FileStatus.UPLOADING"><mat-spinner [diameter]="40"></mat-spinner></span>
                      </div>
                      <div class="FileUploadInputItemActions">
                        <button mat-icon-button *ngIf="isEditable" tabindex="0" class="ruButton small-icon-button" (click)="actionDeleteFile($event, file)">
                          <mat-icon>delete</mat-icon>
                        </button>
                        <button mat-icon-button *ngIf="!isPreview && !isEditable && file.canDownload" tabindex="0" class="ruButton small-icon-button" (click)="downloadFile(file)">
                          <mat-icon>get_app</mat-icon>
                        </button>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- SCHEDULE -->
<div #editSchedule class="d-flex flex-column cdc-form-field"
     *ngIf="editing && component.type === ComponentType.SCHEDULE && isEditable"
     [attr.data-editable]="isEditable"
     [attr.data-type]="componentFullType">
  <div class="cdc-form-field-container">
    <div class="cdc-label">
      <span class="text-new-lines" *ngIf="component.title && component.title.trim() !== ''">
        {{ component.title }}
      </span>
      <mat-icon class="component-title-help"
                *ngIf="component.helpText && component.helpText.length > 0"
                matTooltipClass="multiline-tooltip"
                matTooltip="{{component.helpText}}"
                [matTooltipPosition]="'right'"
                (click)="toggleTooltip(tooltip6)"
                #tooltip6="matTooltip">help</mat-icon>
      <span *ngIf="dataIndex !== undefined && component.title">{{dataIndex}}</span>
      <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
    </div>
    <div class="cdc-label-description text-new-lines" *ngIf="component.description && component.description.trim() !== ''">
      {{ component.description }}
    </div>
    <div class="weekDay-buttons">
      <button mat-stroked-button
              class="weekDay" [ngClass]="{'selected': selectedDay === schedule.weekDay}"
              [disabled]="!isScheduleValid && selectedDay !== schedule.weekDay"
              *ngFor="let schedule of customerPageDataValuesInSchedule"
              (click)="selectDay(schedule.weekDay)"
              [matTooltip]="schedule.weekDay | translate">
        <div>
          {{ (schedule.weekDay | translate)[0] }}
          <div class="weekDayHours"><span>{{ getTotalHoursFormatted(schedule) }}</span></div>
        </div>
      </button>
      <button mat-stroked-button class="weekDay fullDay">
        <mat-checkbox [(ngModel)]="isFullDayChecked" (change)="onFullDayToggle($event.checked)">
          24/24
        </mat-checkbox>
      </button>
    </div>

    <div *ngIf="selectedDay" class="periods-control">
      <ng-container *ngIf="!isSelectedDayFullDay()">
        <div *ngFor="let period of currentSelectedDayPeriods; let i = index">
          <div class="custom-tooltip tooltip-{{ generatedIndex }}-{{i}}" #customTooltip>{{errorMessages[generatedIndex+'-'+i]}}</div>
          <div class="field-{{generatedIndex}}-{{i}} d-flex flex-row gap-1" [ngClass]="{
          'error': errorMessages[generatedIndex+'-'+i],
          'actif': !isAllValuesComponentEmpty() && !errorMessages[generatedIndex+'-'+i] && isEditable
        }">
            <select [(ngModel)]="period.openingTime"
                    (ngModelChange)="onPeriodTimeChanged(period)"
                    inactif
                    matNativeControl>
              <option *ngFor="let hour of availableHours"
                      [value]="hour+':00'"
                      [disabled]="hour === '23:55'">
                {{ hour }}
              </option>
            </select>

            <select [(ngModel)]="period.closingTime"
                    (ngModelChange)="onPeriodTimeChanged(period)"
                    inactif
                    matNativeControl>
              <option *ngFor="let hour of availableHours"
                      [value]="hour+':00'"
                      [disabled]="hour === '00:00'">
                {{ hour }}
              </option>
            </select>

            <a (click)="removePeriod(i)" class="rem-period">
              <mat-icon>close</mat-icon>
            </a>
          </div>
        </div>
      </ng-container>
      <a (click)="addPeriod()" *ngIf="!isSelectedDayFullDay()" class="add-period">
        <mat-icon>add_circle</mat-icon> {{'Add a time slot' | translate}}
      </a>
    </div>
    <button mat-flat-button (click)="onScheduleSave()" class="mt-2 cdc-button schedule-btn" [ngClass]="{'deactivated': !isScheduleValid}" [disabled]="!isScheduleValid">{{'Save' | translate}}</button>
  </div>
</div>

<div #previewSchedule
     class="preview-component cdc-form-field"
     *ngIf="!editing && component.type === ComponentType.SCHEDULE"
     [attr.data-editable]="isEditable"
     [attr.data-type]="componentFullType">
  <div class="cdc-form-field-container">
    <div class="cdc-label">
      <span class="text-new-lines" *ngIf="component.title && component.title.trim() !== ''">
        {{ component.title }}
      </span>
      <mat-icon class="component-title-help"
                *ngIf="component.helpText && component.helpText.length > 0"
                matTooltipClass="multiline-tooltip"
                matTooltip="{{component.helpText}}"
                [matTooltipPosition]="'right'"
                (click)="toggleTooltip(tooltip7)"
                #tooltip7="matTooltip">help</mat-icon>
      <span *ngIf="dataIndex !== undefined && component.title">{{dataIndex}}</span>
      <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
    </div>
    <div class="cdc-label-description text-new-lines" *ngIf="component.description && component.description.trim() !== ''">
      {{ component.description }}
    </div>
    <div class="custom-tooltip tooltip-{{ generatedIndex }}" #customTooltip>{{errorMessages[generatedIndex]}}</div>
    <div class="field-{{generatedIndex}}">
      <div class="summary-edit-area"
           #fieldContainer [attr.data-block-id]="block.id" [attr.data-block-iteration]="block.iteration" [attr.data-component-id]="component.id" [attr.data-component-multiple-iteration]="0" [attr.data-dataGroup-id]="this.customerPageData.dataGroupId"
           [matTooltip]="(isSummary && isEditableWhenNotSummary) ? ('Click here to modify the answer on the questionnaire' | translate) : '' ">
        <div class="w-100" (click)="onEditSchedule(generatedIndex)"
             [ngClass]="{
            'not-allowed': !isEditable,
            'not-editing': isEditable
          }">
          <div *ngFor="let schedule of customerPageDataValuesInSchedule" class="schedule-info">
            <p class="d-flex justify-content-start">
              <span class="week-day-name">
                {{ schedule.weekDay | translate }}
              </span>
              <span *ngIf="schedule.periods && isFullDay(schedule.periods)" class="w-50">
                {{'Open 24h' | translate}}
              </span>
              <span *ngIf="schedule.periods && schedule.periods.length > 0 && !isFullDay(schedule.periods)" class="w-50">
                <span class="period-text" *ngFor="let period of schedule.periods">
                  {{ formatTimeDisplay(period.openingTime) }} - {{ formatTimeDisplay(period.closingTime) }}
                </span>
              </span>

              <span *ngIf="!schedule.periods || schedule.periods.length === 0" class="w-50">
                {{'Closed' | translate}}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- CHECKBOX -->
<div class="d-flex flex-row gap-2"
     *ngIf="component.type == ComponentType.CHECKBOX"
     [attr.data-editable]="isEditable"
     [attr.data-type]="componentFullType">
  <div class="input-component w-100">
    <div>
      <div class="cdc-form-field-container">
        <div class="custom-tooltip tooltip-{{ generatedIndex }}" #customTooltip>{{errorMessages[generatedIndex]}}</div>
        <div>
          <!-- select LIST_NO_DROP multiple (checkbox)-->
          <section class="d-flex flex-column cdc-form-field">
            <div class="cdc-form-field-container">
              <div class="cdc-label">
                <span class="text-new-lines" *ngIf="component.title && component.title.trim() !== ''">
                  {{ component.title }}
                </span>
                <mat-icon class="component-title-help"
                          *ngIf="component.helpText && component.helpText.length > 0"
                          matTooltipClass="multiline-tooltip"
                          matTooltip="{{component.helpText}}"
                          [matTooltipPosition]="'right'"
                          (click)="toggleTooltip(tooltip8)"
                          #tooltip8="matTooltip">help</mat-icon>
                <span *ngIf="dataIndex !== undefined && component.title">{{dataIndex}}</span>
                <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
              </div>
              <div class="cdc-label-description text-new-lines" *ngIf="component.description && component.description.trim() !== ''">
                {{ component.description }}
              </div>
              <div class="custom-tooltip tooltip-{{ generatedIndex }}" #customTooltip>{{errorMessages[generatedIndex]}}</div>
              <div class="field-{{generatedIndex}}">
                <div class="summary-edit-area"
                     #fieldContainer [attr.data-block-id]="block.id" [attr.data-block-iteration]="block.iteration" [attr.data-component-id]="component.id" [attr.data-component-multiple-iteration]="0" [attr.data-dataGroup-id]="this.customerPageData.dataGroupId"
                     [matTooltip]="(isSummary && isEditableWhenNotSummary) ? ('Click here to modify the answer on the questionnaire' | translate) : '' ">
                  <ng-container>
                    <div class="">
                      <section class="d-flex flex-column" [ngClass]="{'not-allowed': !isEditable}">
                        <mat-checkbox attr.data-componentid="{{ component.id }}"
                                      [checked]="isCheckboxComponentChecked"
                                      (click)="displayCurrentErrorTooltip(generatedIndex)"
                                      (change)="onSingleCheckboxChange($event)"
                                      [disabled]="!isEditable">
                          {{ component.config?.text }}
                        </mat-checkbox>
                      </section>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>
    </div>
  </div>

  <div class="container-element w-100" *ngIf="itsConditioner && hasComponentsConditionedClosedDisplayed()">
    <div *ngFor="let componentConditioned of getConditionedComponents('display', true)">
      <app-component-form [customerPageData]="getCustomerPageDataByComponentId(componentConditioned.id, customerPageData.dataGroupId)"
                          [component]="componentConditioned"
                          [block]="block"
                          [customerId]="customerId"
                          [dataGroupCustomerPageData]="dataGroupCustomerPageData"
                          [groupCustomerPageData]="groupCustomerPageData"
                          [pageCustomerPageData]="pageCustomerPageData"
                          [totalDataGroups]="totalDataGroups"
                          [isConditionedClosed]="true"
                          [userRole]="userRole"
                          [customer]="customer"
                          [isSummary]="isSummary"
                          [offerStatus]="offerStatus"
                          [dataIndex]="dataIndex"
                          [index]="index"
                          [customerPage]="customerPage"
                          [refBusinessLists]="refBusinessLists"
                          [fullConnectionsDefinitions]="fullConnectionsDefinitions"
                          [isCurrentBlock]="isCurrentBlock"
                          (customersDataChange)="handleCustomerPageDatasChange($event)"
                          (scrollToSchedule)="scrollToScheduleEvent($event)"
                          (tooltipPosition)="onTooltipPositionChanged($event)"
                          (fieldContainerClick)="onFieldContainerClick($event)"
                          (recalculateTooltipsPosition)="recalculateTooltipsPositionEmit()"
                          (closeAllTooltipsExceptCurrent)="closeAllTooltipsExceptCurrentEmit($event)"
                          (activityChanged)="onConditionedActivityChanged()"
                          [activitiesAlreadySelected]="activitiesAlreadySelected">
      </app-component-form>
    </div>
  </div>
</div>

<!-- COLOR PICKER -->
<div class="input-component"
     *ngIf="component.type == ComponentType.INPUT && component.config?.inputType == InputType.COLOR_PICKER"
     [attr.data-editable]="isEditable"
     [attr.data-type]="componentFullType">
  <div class="cdc-label">
    <span class="text-new-lines" *ngIf="component.title && component.title.trim() !== ''">
      {{ component.title }}
    </span>
    <mat-icon class="component-title-help"
              *ngIf="component.helpText && component.helpText.length > 0"
              matTooltipClass="multiline-tooltip"
              matTooltip="{{component.helpText}}"
              [matTooltipPosition]="'right'"
              (click)="toggleTooltip(tooltip9)"
              #tooltip9="matTooltip">help</mat-icon>
    <span *ngIf="dataIndex !== undefined && component.title">{{dataIndex}}</span>
    <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
  </div>
  <div class="cdc-label-description text-new-lines" *ngIf="component.description && component.description.trim() !== ''">
    {{ component.description }}
  </div>
  <div *ngFor="let value of customerPageDataValuesInColorPicker; let i = index; trackBy: trackByFn" class="d-flex flex-row align-items-center">
    <div class="custom-tooltip tooltip-{{ generatedIndex }}-{{i}}" #customTooltip>{{errorMessages[generatedIndex+'-'+i]}}</div>
    <div class=" w-100 field-{{generatedIndex}}-{{i}}">
      <div class="container-element d-flex flex-row align-items-center gap-2 col-12 col-lg-12 col-md-12">
        <div [ngClass]="{'w-95': canRemoveAnswers(), 'w-100': !canRemoveAnswers()}" class="cdc-form-field color-picker-group">
          <div class="cdc-form-field-container">
            <div class="summary-edit-area d-flex"
                 #fieldContainer [attr.data-block-id]="block.id" [attr.data-block-iteration]="block.iteration" [attr.data-component-id]="component.id" [attr.data-component-multiple-iteration]="i" [attr.data-dataGroup-id]="this.customerPageData.dataGroupId"
                 [matTooltip]="(isSummary && isEditableWhenNotSummary) ? ('Click here to modify the answer on the questionnaire' | translate) : '' ">
              <!-- color text -->
              <div class="color-picker-text"
                   *ngIf="component.config?.hasColorText === true"
                   [ngClass]="{
                'error': errorMessages[generatedIndex+'-'+i],
                'actif': value.text && isEditable
              }">
                <input matInput
                       type="text"
                       autocomplete="off"
                       attr.data-componentid="{{ component.id }}"
                       attr.data-value="{{ value.text }}"
                       [(ngModel)]="value.text"
                       (click)="displayCurrentErrorTooltip(generatedIndex+'-'+i)"
                       (focusout)="onInputSave(value, i)"
                       (ngModelChange)="handleColorPicker(false, value, i)"
                       [placeholder]="isEditable ? (component.config?.placeholder + (component.multipleConfig?.haveIndexTitles ? ' ' + (i+1) : '')) : ''"
                       [disabled]="!isEditable"
                       [ngClass]="{'not-allowed': !isEditable}">
              </div>
              <!-- color pickler -->
              <div class="d-flex"
                   [ngClass]="{
                'color-picker-margin': component.config?.hasColorText,
                'w-100': !component.config?.hasColorText,
                'error': errorMessages[generatedIndex+'-'+i]
              }">
                <ngx-colors ngx-colors-trigger
                            [(ngModel)]="value.color"
                            (click)="displayCurrentErrorTooltip(generatedIndex+'-'+i)"
                            [formats]="['hex']"
                            (slider)="onSliderChange($event, i)"
                            (close)="onInputSave(value, i)"
                            [ngClass]="{'color-picker-disabled': !isEditable}"
                            [disabled]="!isEditable"
                            [acceptLabel]="''"
                            [cancelLabel]="''">
                </ngx-colors>
              </div>
            </div>
          </div>
        </div>

        <button *ngIf="canRemoveAnswers()" mat-icon-button matTooltip="{{ 'Remove answer' | translate }}" (click)="removeAnswer(i)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- BUTTON -->
<div class="cdc-form-field" *ngIf="component.type === ComponentType.BUTTON">
  <div class="cdc-label">
    <span class="text-new-lines" *ngIf="component.title && component.title.trim() !== ''">
      {{ component.title }}
    </span>
    <span *ngIf="dataIndex !== undefined && component.title">{{dataIndex}}</span>
    <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
  </div>
  <div class="cdc-label-description text-new-lines" *ngIf="component.description && component.description.trim() !== ''">
    {{ component.description }}
  </div>
  <a mat-flat-button
     [attr.href]="component.config?.text"
     target="_blank" class="w-100 cdc-button">
    {{ component.config?.placeholder }}
  </a>
</div>

<!-- TEXT -->
<div class="cdc-form-field" *ngIf="component.type === ComponentType.TEXT">
  <div class="cdc-label">
    <span class="text-new-lines" *ngIf="component.title && component.title.trim() !== ''">
      {{ component.title }}
    </span>
    <span *ngIf="dataIndex !== undefined && component.title">{{dataIndex}}</span>
    <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
  </div>
  <div class="cdc-label-description text-new-lines" *ngIf="component.description && component.description.trim() !== ''">
    {{ component.description }}
  </div>
  <span class="cdc-label-text text-new-lines">{{ component.config?.text }}</span>
</div>

<!-- TITLE -->
<div class="cdc-label" *ngIf="component.type == ComponentType.TITLE">
  <h2 class="cdc-component-title text-new-lines">{{component.title}}{{dataIndex !== undefined ? ' '+dataIndex : ''}}</h2>
  <mat-icon class="component-title-help"
            *ngIf="component.helpText && component.helpText.length > 0"
            matTooltipClass="multiline-tooltip"
            matTooltip="{{component.helpText}}"
            [matTooltipPosition]="'right'"
            (click)="toggleTooltip(tooltip10)"
            #tooltip10="matTooltip">help</mat-icon>
</div>

<!-- HTML -->
<div class="cdc-label" *ngIf="component.type == ComponentType.HTML">
  <div class="component-html-wrapper" #htmlWrapper [innerHtml]="sanitizeHtml(component.config!.text!)"></div>
  <mat-icon class="component-title-help"
            *ngIf="component.helpText && component.helpText.length > 0"
            matTooltipClass="multiline-tooltip"
            matTooltip="{{component.helpText}}"
            [matTooltipPosition]="'right'"
            (click)="toggleTooltip(tooltip11)"
            #tooltip11="matTooltip">help</mat-icon>
</div>

<!-- ADDRESS -->
<div class="d-flex flex-column cdc-form-field"
     *ngIf="component.type === ComponentType.ADDRESS"
     [attr.data-editable]="isEditable"
     [attr.data-type]="componentFullType">
  <div class="cdc-form-field-container">
    <div class="cdc-label">
      <span class="text-new-lines" *ngIf="component.title && component.title.trim() !== ''">
        {{ component.title }}
      </span>
      <mat-icon class="component-title-help"
                *ngIf="component.helpText && component.helpText.length > 0"
                matTooltipClass="multiline-tooltip"
                matTooltip="{{component.helpText}}"
                [matTooltipPosition]="'right'"
                (click)="toggleTooltip(tooltip6)"
                #tooltip6="matTooltip">help</mat-icon>
      <span *ngIf="dataIndex !== undefined && component.title">{{dataIndex}}</span>
      <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
    </div>
    <div class="cdc-label-description text-new-lines" *ngIf="component.description && component.description.trim() !== ''">
      {{ component.description }}
    </div>

    <div class="custom-tooltip tooltip-{{ generatedIndex }}" #customTooltip>{{errorMessages[generatedIndex]}}</div>
    <div class="field-{{generatedIndex}}" *ngFor="let value of customerPageDataValuesInAddress;let i = index">
      <div class="summary-edit-area"
           #fieldContainer [attr.data-block-id]="block.id" [attr.data-block-iteration]="block.iteration" [attr.data-component-id]="component.id" [attr.data-component-multiple-iteration]="i" [attr.data-dataGroup-id]="this.customerPageData.dataGroupId"
           [matTooltip]="(isSummary && isEditableWhenNotSummary) ? ('Click here to modify the answer on the questionnaire' | translate) : '' ">
        <div class="d-flex flex-row flex-wrap align-items-start col-12 col-lg-12 col-md-12">
          <div class="cdc-form-field col-12 col-lg-12 col-md-12 p-1"
               [ngClass]="{
              'error': errorMessages[generatedIndex] && !value.extendedWayLabel,
              'actif': value.extendedWayLabel && isEditable,
              'm-0':isConditionedClosed,
              'not-allowed': !isEditable,
              'not-editing': isEditable && !editing
            }"
               (click)="activateEdit(generatedIndex)">
            <input matInput
                   type="text"
                   autocomplete="off"
                   [placeholder]="isEditable ? ('Nº, ' + ('track type' | translate) + ', ' + ('lane label' | translate)) : ''"
                   (click)="displayCurrentErrorTooltip(generatedIndex)"
                   [(ngModel)]="value.extendedWayLabel"
                   (focusout)="onAddressFieldChanged()"
                   [disabled]="!editing || !isEditable">
          </div>

          <div class="cdc-form-field col-3 col-lg-3 col-md-3 p-1"
               [ngClass]="{
              'error': errorMessages[generatedIndex] && !value.postalCode,
              'actif': value.postalCode && isEditable,
              'm-0':isConditionedClosed,
              'not-allowed': !isEditable,
              'not-editing': isEditable && !editing
            }"
               (click)="activateEdit(generatedIndex)">
            <input matInput
                   type="text"
                   autocomplete="off"
                   [placeholder]="isEditable ? ('Postal code' | translate) : ''"
                   (click)="displayCurrentErrorTooltip(generatedIndex)"
                   [(ngModel)]="value.postalCode"
                   (focusout)="onAddressFieldChanged()"
                   [disabled]="!editing || !isEditable">
          </div>

          <div class="cdc-form-field col-6 col-lg-6 col-md-6 p-1"
               [ngClass]="{
              'error': errorMessages[generatedIndex] && !value.localityLabel,
              'actif': value.localityLabel && isEditable,
              'm-0':isConditionedClosed,
              'not-allowed': !isEditable,
              'not-editing': isEditable && !editing
            }"
               (click)="activateEdit(generatedIndex)">
            <input matInput
                   type="text"
                   autocomplete="off"
                   [placeholder]="isEditable ? ('City' | translate) : ''"
                   (click)="displayCurrentErrorTooltip(generatedIndex)"
                   [(ngModel)]="value.localityLabel"
                   (focusout)="onAddressFieldChanged()"
                   [disabled]="!editing || !isEditable">
          </div>

          <div class="cdc-form-field col-3 col-lg-3 col-md-3 p-1"
               [ngClass]="{
              'error': errorMessages[generatedIndex] && !value.countryCode,
              'actif': value.countryCode && isEditable,
              'm-0':isConditionedClosed,
              'not-allowed': !isEditable,
              'not-editing': isEditable && !editing
            }"
               (click)="activateEdit(generatedIndex)">
            <div class="select-container">
              <select [(ngModel)]="value.countryCode"
                      (click)="displayCurrentErrorTooltip(generatedIndex)"
                      (ngModelChange)="onAddressFieldChanged()"
                      inactif
                      matNativeControl
                      [disabled]="!editing || !isEditable"
                      [class.placeholder-shown]="!value.countryCode">
                <option value="" disabled selected hidden>{{ isEditable ? ('Country' | translate) : ''}}</option>
                <option *ngFor="let option of countries"
                        attr.data-componentid="{{ component.id }}"
                        attr.data-value="{{ option.code }}"
                        [value]="option.code">
                  {{ option.labelBusiness }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button *ngIf="editing && hasConnectionsOut"
            class="cdc-button mt-2"
            mat-flat-button
            (click)="onAddressSave()"
            [ngClass]="{'deactivated': !isAddressValid}"
            [disabled]="!isAddressValid">
      {{'Save' | translate}}
    </button>
  </div>
</div>

<!-- INTITULE -->
<div class="d-flex flex-column cdc-form-field"
     *ngIf="component.type === ComponentType.INTITULE"
     [attr.data-editable]="isEditable"
     [attr.data-type]="componentFullType">
  <div class="cdc-form-field-container">
    <div class="cdc-label">
      <span class="text-new-lines" *ngIf="component.title && component.title.trim() !== ''">
        {{ component.title }}
      </span>
      <mat-icon class="component-title-help"
                *ngIf="component.helpText && component.helpText.length > 0"
                matTooltipClass="multiline-tooltip"
                matTooltip="{{component.helpText}}"
                [matTooltipPosition]="'right'"
                (click)="toggleTooltip(tooltip6)"
                #tooltip6="matTooltip">help</mat-icon>
      <span *ngIf="dataIndex !== undefined && component.title">{{dataIndex}}</span>
      <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
    </div>
    <div class="cdc-label-description text-new-lines" *ngIf="component.description && component.description.trim() !== ''">
      {{ component.description }}
    </div>

    <div class="custom-tooltip tooltip-{{ generatedIndex }}" #customTooltip>{{errorMessages[generatedIndex]}}</div>
    <div class="field-{{generatedIndex}}" *ngFor="let value of customerPageDataValuesInIntitule;let i = index">
      <div class="summary-edit-area"
           #fieldContainer [attr.data-block-id]="block.id" [attr.data-block-iteration]="block.iteration" [attr.data-component-id]="component.id" [attr.data-component-multiple-iteration]="i" [attr.data-dataGroup-id]="this.customerPageData.dataGroupId"
           [matTooltip]="(isSummary && isEditableWhenNotSummary) ? ('Click here to modify the answer on the questionnaire' | translate) : '' ">
        <div class="d-flex flex-row flex-wrap align-items-start col-12 col-lg-12 col-md-12">
          <div class="cdc-form-field p-1"
               [ngClass]="{
              'error': errorMessages[generatedIndex],
              'actif': value.denomination && isEditable,
              'm-0':isConditionedClosed,
              'col-6 col-lg-6 col-md-6': value.denominationComplement || isEditable,
              'col-12 col-lg-12 col-md-12': !(value.denominationComplement || isEditable)
            }">
            <input matInput
                   type="text"
                   autocomplete="off"
                   [placeholder]="isEditable ? ('Denomination' | translate) : ''"
                   [(ngModel)]="value.denomination"
                   (focusout)="onIntituleSave()"
                   [ngClass]="{'not-allowed': !isEditable}"
                   [disabled]="!isEditable">
          </div>

          <div *ngIf="value.denominationComplement || isEditable"
              class="cdc-form-field col-6 col-lg-6 col-md-6 p-1"
               [ngClass]="{
              'actif': value.denominationComplement && isEditable,
              'm-0':isConditionedClosed,
              'not-allowed': !isEditable
            }">
            <input matInput
                   type="text"
                   autocomplete="off"
                   [placeholder]="isEditable ? ('Denomination complement' | translate) : ''"
                   [(ngModel)]="value.denominationComplement"
                   (focusout)="onIntituleSave()">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- URL -->
<div class="d-flex flex-column cdc-form-field"
     *ngIf="component.type === ComponentType.URL"
     [attr.data-editable]="isEditable"
     [attr.data-type]="componentFullType">
  <div class="cdc-form-field-container">
    <div class="cdc-label">
      <span class="text-new-lines" *ngIf="component.title && component.title.trim() !== ''">
        {{ component.title }}
      </span>
      <mat-icon class="component-title-help"
                *ngIf="component.helpText && component.helpText.length > 0"
                matTooltipClass="multiline-tooltip"
                matTooltip="{{component.helpText}}"
                [matTooltipPosition]="'right'"
                (click)="toggleTooltip(tooltip6)"
                #tooltip6="matTooltip">help</mat-icon>
      <span *ngIf="dataIndex !== undefined && component.title">{{dataIndex}}</span>
      <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
    </div>
    <div class="cdc-label-description text-new-lines" *ngIf="component.description && component.description.trim() !== ''">
      {{ component.description }}
    </div>

    <div *ngFor="let value of customerPageDataValuesInUrl;let i = index" class="d-flex flex-row align-items-center">
      <div class="custom-tooltip tooltip-{{ generatedIndex }}-{{i}}" #customTooltip>{{errorMessages[generatedIndex+'-'+i]}}</div>
      <div class="field-{{generatedIndex}}-{{i}} d-flex flex-row align-items-center w-100">
        <div class="summary-edit-area"
             [ngClass]="{'w-95': canRemoveAnswers(), 'w-100': !canRemoveAnswers()}"
             #fieldContainer [attr.data-block-id]="block.id" [attr.data-block-iteration]="block.iteration" [attr.data-component-id]="component.id" [attr.data-component-multiple-iteration]="i" [attr.data-dataGroup-id]="this.customerPageData.dataGroupId"
             [matTooltip]="(isSummary && isEditableWhenNotSummary) ? ('Click here to modify the answer on the questionnaire' | translate) : '' ">
          <div class="d-flex flex-row flex-wrap align-items-start col-12 col-lg-12 col-md-12">

            <div div *ngIf="component.config?.contentAPISubType == 'CUSTOM'"
                 class="cdc-form-field col-6 col-lg-6 col-md-6 p-1"
                 [ngClass]="{
                'error': errorMessages[generatedIndex+'-'+i],
                'actif': !errorMessages[generatedIndex+'-'+i] && value.type && isEditable,
                'm-0':isConditionedClosed,
                'not-allowed': !isEditable
              }">
              <div class="select-container">
                <select [(ngModel)]="value.type"
                        (click)="displayCurrentErrorTooltip(generatedIndex+'-'+i)"
                        (ngModelChange)="onUrlSave(value)"
                        inactif
                        matNativeControl
                        [class.placeholder-shown]="!value.type"
                        [disabled]="!isEditable">
                  <option value="" disabled selected hidden>{{ isEditable ? ('URL type' | translate) : ''}}</option>
                  <option *ngFor="let option of urlTypes"
                          attr.data-componentid="{{ component.id }}"
                          attr.data-value="{{ option.code }}"
                          [value]="option.code">
                    {{ option.labelBusiness }}
                  </option>
                </select>
              </div>
            </div>

            <div class="cdc-form-field p-1"
                 [ngClass]="{
                'error': errorMessages[generatedIndex+'-'+i],
                'actif': !errorMessages[generatedIndex+'-'+i] && value.label && isEditable,
                'm-0':isConditionedClosed,
                'col-6 col-lg-6 col-md-6': component.config?.contentAPISubType == 'CUSTOM',
                'col-12 col-lg-12 col-md-12': component.config?.contentAPISubType != 'CUSTOM',
                'not-allowed': !isEditable
              }">
              <input matInput
                     type="text"
                     autocomplete="off"
                     [placeholder]="isEditable ? ('Add URL' | translate) : ''"
                     [(ngModel)]="value.label"
                     (click)="displayCurrentErrorTooltip(generatedIndex+'-'+i)"
                     (focusout)="onUrlSave(value, i)"
                     [disabled]="!isEditable">
            </div>
          </div>
        </div>

        <mat-icon class="remove-answer" *ngIf="canRemoveAnswers()" matTooltip="{{ 'Remove answer' | translate }}" (click)="removeAnswer(i)">close</mat-icon>
      </div>
    </div>

    <a *ngIf="canAddAnswers(true)" (click)="addAnswer()" class="d-flex flex-row align-items-center cdc-add-answer">
      <mat-icon>add</mat-icon> {{component.multipleConfig?.textBtnMultiple}}
    </a>

  </div>
</div>

<!-- ACTIVITY_PRESTATIONS -->
<div class="d-flex flex-column cdc-form-field"
     *ngIf="component.type === ComponentType.ACTIVITY_PRESTATIONS"
     [attr.data-editable]="isEditable"
     [attr.data-type]="componentFullType">
  <div class="cdc-form-field-container">
    <div class="cdc-label">
      <span class="text-new-lines" *ngIf="component.title && component.title.trim() !== ''">
        {{ component.title }}
      </span>
      <mat-icon class="component-title-help"
                *ngIf="component.helpText && component.helpText.length > 0"
                matTooltipClass="multiline-tooltip"
                matTooltip="{{component.helpText}}"
                [matTooltipPosition]="'right'"
                (click)="toggleTooltip(tooltip6)"
                #tooltip6="matTooltip">help</mat-icon>
      <span *ngIf="dataIndex !== undefined && component.title">{{dataIndex}}</span>
      <span *ngIf="component.isRequired === true && component.title" matTooltip="{{'Required'| translate}}">*</span>
    </div>
    <div class="cdc-label-description text-new-lines" *ngIf="component.description && component.description.trim() !== ''">
      {{ component.description }}
    </div>

    <div *ngFor="let activityPrestation of customerPageDataValuesInActivityPrestations;let i = index" class="d-flex flex-row align-items-center">
      <div class="custom-tooltip tooltip-{{ generatedIndex }}-{{i}}" #customTooltip>{{errorMessages[generatedIndex+'-'+i]}}</div>
      <div class="field-{{generatedIndex}}-{{i}} d-flex flex-row align-items-center w-100">
        <div class="summary-edit-area"
             [ngClass]="{'w-95': canRemoveAnswers(), 'w-100': !canRemoveAnswers()}"
             #fieldContainer [attr.data-block-id]="block.id" [attr.data-block-iteration]="block.iteration" [attr.data-component-id]="component.id" [attr.data-component-multiple-iteration]="i" [attr.data-dataGroup-id]="this.customerPageData.dataGroupId"
             [matTooltip]="(isSummary && isEditableWhenNotSummary) ? ('Click here to modify the answer on the questionnaire' | translate) : '' ">
          <div class="d-flex flex-row flex-wrap align-items-start col-12 col-lg-12 col-md-12">

            <div class="cdc-form-field col-12 col-lg-12 col-md-12 p-1"
                 [ngClass]="{
                 'error' : errorMessages[generatedIndex+'-'+i],
                 'actif' : !errorMessages[generatedIndex+'-'+i] && activityPrestation.activity && activityPrestation.prestations.length <= 0 && isEditable,
                'm-0':isConditionedClosed,
                'not-allowed': !isEditable || (activityPrestation.activity && activityPrestation.prestations.length > 0)
              }">
              <div class="cdc-label">
                <span class="text-new-lines">
                  {{activityPrestation.activity?.mainIndicator ? ('Main activity' | translate) : ( 'Activity' | translate) }}
                </span>
                <span *ngIf="dataIndex !== undefined && !activityPrestation.activity?.mainIndicator">{{dataIndex}}</span>
              </div>

              <div class="select-container">
                <input type="text"
                    matInput
                    placeholder="{{ 'Activity' | translate }}"
                    [matAutocomplete]="autoActivities"
                    [formControl]="activityCtrl"
                    [readonly]="true"
                    (click)="openPanelManually(generatedIndex+'-'+i)"
                    (blur)="onSelectActivityFocusOut()"/>

                <mat-autocomplete #autoActivities="matAutocomplete"
                                  [displayWith]="displayActivity"
                                  (optionSelected)="onActivitySelected($event.option.value)"
                                  (opened)="onPanelOpen('activities')"
                                  (optionActivated)="onOptionActivated($event)"
                                  autoActiveFirstOption>
                  <div class="search-input-container" (click)="$event.stopPropagation()">
                    <mat-icon matPrefix>search</mat-icon>
                      <input #searchInput
                              type="text"
                              [placeholder]="isEditable ? (('Search' | translate) + '...') : ''"
                              [formControl]="activitySearchCtrl"
                              class="mat-autocomplete-search-input"
                              (keydown.enter)="onSelectActivitySearchEnter($event)" />
                  </div>
                  <hr class="search-divider">
                    <ng-container *ngIf="filteredActivitiesState | async as state">
                      <mat-option *ngIf="state.isWaitingForInput" [disabled]="true">
                        {{"Type to search" | translate}}
                      </mat-option>

                      <mat-option *ngIf="state.notFound" [disabled]="true">
                        {{"Not found" | translate}}
                      </mat-option>

                      <mat-option *ngFor="let activity of state.filteredActivities" [value]="activity">
                        {{ activity.label }}
                      </mat-option>
                    </ng-container>
                </mat-autocomplete>
              </div>
            </div>

            <div class="cdc-form-field w-95 p-1 ml-5 cdc-form-field-prestations"
                 *ngIf="hasAvailablePrestations"
                 [ngClass]="{
                 'actif' : !errorMessages[generatedIndex+'-'+i] && activityPrestation.prestations.length>
              0 && isEditable,
              'error': errorMessages[generatedIndex+'-'+i],
              'm-0':isConditionedClosed,
              'not-allowed': !isEditable || !activityPrestation.activity
              }">
              <div class="cdc-label">
                <span class="text-new-lines">
                  {{ 'Services' | translate }}
                </span>
              </div>
              <mat-form-field class="select-container select-chips w-100">
                <mat-chip-grid #chipListPrestations>

                  <mat-chip *ngFor="let prestation of activityPrestation.prestations"
                            (removed)="removePrestation(prestation, activityPrestation.activity!.code)"
                            [removable]="isEditable">
                    {{ prestation.label }}
                    <button matChipRemove *ngIf="isEditable" matTooltip="{{ 'Remove service' | translate }}">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip>

                  <input [placeholder]="isEditable ? ('Services' | translate) : ''"
                         #prestationInput
                         [formControl]="prestationCtrl"
                         [matAutocomplete]="autoPrestations"
                         [matChipInputFor]="chipListPrestations"
                         [disabled]="!isEditable || !activityPrestation.activity"
                         (click)="onClickInputPrestation(generatedIndex+'-'+i)"
                         (blur)="onSelectPrestationFocusOut()" class="select-input-multiple" />
                </mat-chip-grid>

                <mat-autocomplete #autoPrestations="matAutocomplete"
                                  [displayWith]="displayPrestation"
                                  (optionSelected)="onPrestationSelected($event.option.value, activityPrestation.activity!.code)"
                                  (opened)="onPanelOpen('prestations')"
                                  autoActiveFirstOption>
                  <ng-container *ngIf="filteredPrestationsState | async as state">
                    <mat-option *ngIf="state.isWaitingForInput" [disabled]="true">
                      {{"Type to search" | translate}}
                    </mat-option>

                    <mat-option *ngIf="state.notFound" [disabled]="true">
                      {{"Not found" | translate}}
                    </mat-option>

                    <mat-option *ngFor="let prestation of state.filteredPrestations" [value]="prestation">
                      {{ prestation.label }}
                    </mat-option>
                  </ng-container>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MULTIPLE BTN -->
<a *ngIf="canAddAnswers()" (click)="addAnswer()" class="d-flex flex-row align-items-center cdc-add-answer">
  <mat-icon [matTooltip]="component.multipleConfig?.textBtnMultiple ? '' : ('Add answer' | translate)">add</mat-icon> {{component.multipleConfig?.textBtnMultiple}}
</a>
